<template>
  <div class="container">
    <ul class="v-mult-check">
      <li
        class="v-mult-check__item"
        v-for="item in currentQuestion.response"
        :key="item"
        :class="{ 'v-mult-check__item--selected': isSelected(item) }"
        @click="change(item)"
      >
        <p class="v-mult-check__text">{{ item }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "VMultCheck",
  data: () => ({
    value: []
  }),
  computed: {
    ...mapState("Quiz", ["currentQuestion"])
  },
  methods: {
    ...mapMutations("Quiz", ["updateResponse"]),
    isSelected(e) {
      return this.value.some(val => val === e);
    },
    change(e) {
      if (this.isSelected(e)) this.removeResp(e);
      else this.addResp(e);
    },
    removeResp(e) {
      this.value = this.value.filter(val => val !== e);

      this.updateResponse({
        question: this.currentQuestion.uuid,
        response: this.value
      });
    },
    addResp(e) {
      const possibility = {
        CHECK_BOXES: () => {
          const a = this.value.filter(val => val !== e);
          a.push(e);
          this.value = a;
        },
        CHOICES: () => {
          this.value = [e];
          setTimeout(() => {
            this.$emit("continue", true);
          }, 250);
        }
      };

      possibility[this.currentQuestion.type_response]();

      this.updateResponse({
        question: this.currentQuestion.uuid,
        response: this.value
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/components/variables";

.v-mult-check {
  display: flex;
  flex-wrap: wrap;
  margin: -16px;
  justify-content: center;

  overflow: auto;
  max-height: 55vh;
  @media #{$large-and-up} {
      margin: 0px;
      max-width: 100%;
      font-size: 1.5vw;
    }

  &__item {
    min-width: 30vw;
    min-height: 15vw;
    @media #{$large-and-up} {
      min-width: 10vw;
      min-height: 5vw;
    }

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    margin: 16px;
    background: #ffffff;
    border-radius: 16px;

    &--selected {
      background: #242424;
    }
  }
  &__text {
    margin: 0;
    font-size: 4vw;
    
    @media #{$large-and-up} {
      font-size: 1vw;
    }
    text-align: center;
    color: #242424;
  }

  @media #{$small-and-down} {
    &__item {
      min-width: 150px;
    }
    &__text {
      font-size: 24px;
    }
  }

  &__item--selected > &__text {
    color: #fff;
  }
}
</style>
